import * as React from "react"

export enum AppSectionEnum {
    Menu = "_menu",
    Info = "_info",
    Orders = "_orders",
    Cart = "_cart",
    TableOrder = "_tab",
    Login = "_login",
    Profile = "_profile",
    Payments = "_payments",
    Addresses = "_addresses",
    ProductDetail = "_item",
}

export type Stylable = {
    className?: string
    style?: React.CSSProperties
}
